export const OBLIGATORY = [
  {
    id: 1,
    description: 'Sí'
  },
  {
    id: 2,
    description: 'No'
  }
];

export const FACTORBASE = [
  {
    id: 1,
    description: 'Saldo Mensual'
  },
  {
    id: 2,
    description: 'Salario Diario'
  }
];

export const ESTATUS = [
  {
    id: 1,
    description: 'Activo'
  },
  {
    id: 2,
    description: 'Inactivo'
  }
];

export const CalculaBonoAndComisiones = [
  {
    id: 1,
    description: 'Sí'
  },
  {
    id: 2,
    description: 'No'
  }
];